// global
import { isYesterday } from 'date-fns';
// local
import { sortData } from 'app/lib/helper';

const initialState = {
    loading: false,
    data: [],
};

const initSort = () => ({
    column: 'patient.name',
    direction: 'ascending',
});

const findSort = (data, id) => {
    let row = data.find(row => row.id === id);
    return row && row.sort ? row.sort : null;
};

const ACTION_KEY = 'CONFIRM_DELIVERY';

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case `${ACTION_KEY}_PENDING`: {
            return {
                ...state,
                loading: true,
            };
        }
        case `${ACTION_KEY}_REJECTED`: {
            return {
                ...state,
                loading: false,
            };
        }
        case `${ACTION_KEY}_FULFILLED`: {
            let data = action.payload.map(row => {
                let sort = findSort(state.data, row.id);
                if (!sort) {
                    sort = initSort();
                }
                // date that comes from the server is in UTC format, convert to local
                // need to add the timezone offsite, if not it will have -timezoneoffset
                let date = new Date(row.date);
                date.setTime(date.getTime() + date.getTimezoneOffset() * 60000);
                const isFromYesterday = isYesterday(date);
                // Sort the rows
                let entries = sortData(row.entries, sort).map(entry => {
                    const isPending = entry.cylinderQtdConfirmed > 0;
                    const counter = isPending ? entry.cylinderQtdConfirmed : entry.cylinderQtdRequested;
                    return {
                        ...entry,
                        counter,
                        isFromYesterday,
                        isPending,
                        isEdit: false,
                        isSaved: false,
                        hasChanged: false,
                    };
                });
                return {
                    ...row,
                    isFromYesterday,
                    sort,
                    date,
                    entries,
                };
            });
            return {
                ...state,
                loading: false,
                data,
            };
        }
        case `${ACTION_KEY}_RESET`: {
            return {
                ...state,
                data: [],
            };
        }
        case `${ACTION_KEY}_SORT`: {
            let { date, column, direction } = action.payload;
            let sort = { column, direction };
            return {
                ...state,
                data: state.data.map(row => {
                    if (row.date !== date) {
                        return row;
                    }
                    return {
                        ...row,
                        sort,
                        entries: sortData(row.entries, sort),
                    };
                }),
            };
        }
        case `${ACTION_KEY}_MARK_SAVED`: {
            const { date, patientId, counter } = action.payload;
            return {
                ...state,
                data: state.data.map(row => {
                    if (row.date !== date) {
                        return row;
                    }
                    return {
                        ...row,
                        entries: row.entries.map(entry => {
                            if (entry.id !== patientId) {
                                return entry;
                            }
                            return {
                                ...entry,
                                counter,
                                isEdit: false,
                                isSaved: true,
                            };
                        }),
                    };
                }),
            };
        }
        case `${ACTION_KEY}_UPDATE_EDIT`: {
            const { date, patientId, isEdit } = action.payload;
            return {
                ...state,
                data: state.data.map(row => {
                    if (row.date !== date) {
                        return row;
                    }
                    return {
                        ...row,
                        entries: row.entries.map(entry => {
                            if (entry.id !== patientId) {
                                return entry;
                            }
                            return {
                                ...entry,
                                isEdit,
                            };
                        }),
                    };
                }),
            };
        }
        case `${ACTION_KEY}_UPDATE_VALUE`: {
            const { date, patientId, value, hasChanged } = action.payload;
            return {
                ...state,
                data: state.data.map(row => {
                    if (row.date !== date) {
                        return row;
                    }
                    return {
                        ...row,
                        entries: row.entries.map(entry => {
                            if (entry.id !== patientId) {
                                return entry;
                            }
                            return {
                                ...entry,
                                counter: value,
                                hasChanged,
                            };
                        }),
                    };
                }),
            };
        }
        default:
            return state;
    }
};

export default reducer;
